import type { ApplePayConfig, DepositAmountsConfig, DepositPaymentMethods, PaymentsFlags, WithdrawPaymentMethods } from '../../paymentMethods.types';

const DEPOSIT_PAYMENT_METHODS = {
  APPLE_PAY: {
    name: 'Apple Pay',
    'data-track-method': 'Apple Pay',
    'data-track-provider': 'Worldpay',
    apiName: 'WORLDPAY_APPLEPAY',
    minAllowedAmount: 100,
    maxAllowedAmount: 2000000,
  },
  CARD: {
    name: 'Debit card',
    'data-track-method': 'Debit Card',
    'data-track-provider': 'Worldpay',
    apiName: 'worldpaycard',
    minAllowedAmount: 100,
    maxAllowedAmount: 2000000,
  },
  PAYBYBANK: {
    name: 'Pay by Bank',
    'data-track-method': 'Instant Banking',
    'data-track-provider': 'Astro Pay',
    apiName: 'hexopay_truelayer',
    minAllowedAmount: 100,
    maxAllowedAmount: 10000000000,
  },
  PAYSAFECARD: {
    name: 'PaysafeCard',
    'data-track-method': 'PaysafeCard',
    'data-track-provider': 'Paysafe',
    apiName: 'paysafecard',
    minAllowedAmount: 200,
    maxAllowedAmount: 10000000000,
  },
  PAYMENTIQHUB: {
    name: 'More Options',
    'data-track-method': 'More Options',
    'data-track-provider': 'Payment IQ',
    apiName: 'paymentiq_hub',
    minAllowedAmount: 50,
    maxAllowedAmount: 10000000000,
  },
} satisfies Pick<DepositPaymentMethods, 'APPLE_PAY' | 'CARD' | 'PAYBYBANK' | 'PAYSAFECARD' | 'PAYMENTIQHUB'>;

const WITHDRAW_PAYMENT_METHODS = {
  BANK_TRANSFER: {
    name: 'Bank transfer',
    'data-track-method': 'Bank Transfer',
    apiName: 'bank_transfer',
  },
} satisfies WithdrawPaymentMethods;

const paymentMethodsConfig = {
  depositMethods: DEPOSIT_PAYMENT_METHODS,
  withdrawMethods: WITHDRAW_PAYMENT_METHODS,
};

const PAYMENTS_FLAGS = {
  showDepositLimitButtonOnDepositAmountStep: true,
  acceptsAmexCards: false,
  requiresFirstTimeDepositTermsAcceptance: true,
} satisfies PaymentsFlags;

const DEPOSIT_AMOUNTS = {
  defaultAmount: 10_00,
  quickAmounts: [10_00, 25_00, 50_00],
} satisfies DepositAmountsConfig;

const APPLE_PAY_CONFIG: ApplePayConfig = {
  playerCountry: 'GB',
  merchantLabel: 'Lottoland',
};

export { APPLE_PAY_CONFIG, DEPOSIT_AMOUNTS, paymentMethodsConfig, PAYMENTS_FLAGS };
